import * as React from 'react';
import { DatePicker } from 'antd';
import Text from 'antd/lib/typography/Text';
import { Items } from 'components/MarketingCampaign/MarketingCampaignTable';
import { LanguageContext } from 'contexts/LanguageContext';
import { Modal } from 'components/MarketingCampaign/styles';

interface CampaignRescheduleModalProps {
	open: boolean;
	onClose: () => void;
	campaign: Items | undefined;
	onRescheduleCampaign: (id: string, date: moment.Moment) => void;
	loadingReschedule: boolean;
}

const CampaignRescheduleModal: React.FC<CampaignRescheduleModalProps> = ({
	open,
	onClose,
	campaign,
	onRescheduleCampaign,
	loadingReschedule,
}) => {
	const [scheduleDate, setScheduleDate] = React.useState<moment.Moment | null>(null);
	const { dictionary } = React.useContext(LanguageContext);

	const handleChangeScheduledDate = (date: moment.Moment | null) => {
		if (date) {
			date = date.tz('America/Sao_Paulo');
			date.seconds(0);
		}

		setScheduleDate(date);
	};

	return (
		<Modal
			width={300}
			title={campaign?.title}
			visible={open}
			onCancel={onClose}
			closeIcon={onClose}
			confirmLoading={loadingReschedule}
			onOk={() => {
				if (campaign && scheduleDate) onRescheduleCampaign(campaign.id, scheduleDate);
				setScheduleDate(null);
			}}
		>
			<Text type="gray-9">{dictionary.campaign_reschedule}</Text>
			<DatePicker
				style={{ width: '100%' }}
				size="large"
				showTime={{ format: 'HH:mm' }}
				value={scheduleDate}
				onChange={handleChangeScheduledDate}
			/>
		</Modal>
	);
};

export default CampaignRescheduleModal;
